module.exports = __webpack_public_path__ + "static/media/leftOutputGain.1e0487fa.png";